import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function ourWork () {
	const sections = document.querySelectorAll('.our-work');
	if (! sections.length) return;

	const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	sections.forEach((section) => {
		const bar = section.querySelector('.nav-cover-bar');
		if (bar) {
			ScrollTrigger.create({
				trigger: section,
				start: 'top top',
				end: 'bottom top-=16',
				onToggle: (self) => bar.classList.toggle('is-fixed', self.isActive),
			});
		}

		bindResults(section, reduce);
		bindCardVideos(section, '.study');
	});

	ScrollTrigger.refresh();
}

function bindResults (section, reduce) {
	const scroller = section.querySelector('.results');
	const cards = [...section.querySelectorAll('.result')];
	const dots = [...section.querySelectorAll('.results-dot')];
	const prev = section.querySelector('.results-prev');
	const next = section.querySelector('.results-next');
	if (! scroller || cards.length < 2 || ! dots.length) return;

	const inset = () => parseFloat(getComputedStyle(scroller).scrollPaddingLeft) || 0;

	const nearest = () => {
		const edge = scroller.getBoundingClientRect().left + inset();
		let active = 0;
		let best = Infinity;
		cards.forEach((card, index) => {
			const distance = Math.abs(card.getBoundingClientRect().left - edge);
			if (distance < best) {
				best = distance;
				active = index;
			}
		});
		return active;
	};

	const go = (index) => {
		const card = cards[Math.max(0, Math.min(cards.length - 1, index))];
		if (! card) return;
		const left = card.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft - inset();
		scroller.scrollTo({ left, behavior: reduce ? 'auto' : 'smooth' });
	};

	const paint = () => {
		const active = nearest();
		dots.forEach((dot, index) => {
			const on = index === active;
			dot.classList.toggle('is-active', on);
			if (on) dot.setAttribute('aria-current', 'true');
			else dot.removeAttribute('aria-current');
		});
		if (prev) prev.disabled = active === 0;
		if (next) next.disabled = active === cards.length - 1;
	};

	scroller.addEventListener('scroll', paint, { passive: true });
	dots.forEach((dot, index) => {
		dot.addEventListener('click', () => go(index));
	});
	prev?.addEventListener('click', () => go(nearest() - 1));
	next?.addEventListener('click', () => go(nearest() + 1));
	paint();
}

function bindCardVideos (section, cardSelector) {
	const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
	if (reduce || ! fine) return;

	section.querySelectorAll(cardSelector).forEach((card) => {
		const video = card.querySelector('.hover-video');
		if (! video) return;

		let rewindTimer = 0;

		const show = () => {
			if (card.matches(':hover')) video.classList.add('is-playing');
		};

		video.addEventListener('playing', show);

		card.addEventListener('pointerenter', () => {
			window.clearTimeout(rewindTimer);
			const started = video.play();
			if (started && typeof started.catch === 'function') started.catch(() => {});
		});

		card.addEventListener('pointerleave', () => {
			video.classList.remove('is-playing');
			video.pause();
			window.clearTimeout(rewindTimer);
			rewindTimer = window.setTimeout(() => {
				if (! card.matches(':hover')) video.currentTime = 0;
			}, 200);
		});
	});
}
